// src/store/modules/HotRanking.js
import axios from '@/plugins/axios'; // 确保 Axios 已正确配置

const state = {
    platform: 'douyin', // 默认平台
    hotData: [],        // 热榜数据
    total: 0,           // 总条目数
    title: '',          // 热榜标题
    subtitle: '',       // 热榜副标题
    loading: false,     // 加载状态
    error: null,        // 错误信息
};

const getters = {
    /**
     * 获取当前平台的热榜数据
     * @param {Object} state - Vuex 状态对象
     * @returns {Array} 热榜数据数组
     */
    hotData: (state) => state.hotData,

    /**
     * 获取热榜总条目数
     * @param {Object} state
     * @returns {Number} 总条目数
     */
    total: (state) => state.total,

    /**
     * 获取热榜标题
     * @param {Object} state
     * @returns {String} 标题
     */
    title: (state) => state.title,

    /**
     * 获取热榜副标题
     * @param {Object} state
     * @returns {String} 副标题
     */
    subtitle: (state) => state.subtitle,

    /**
     * 获取加载状态
     * @param {Object} state
     * @returns {Boolean} 是否加载中
     */
    loading: (state) => state.loading,

    /**
     * 获取错误信息
     * @param {Object} state
     * @returns {String|null} 错误信息
     */
    error: (state) => state.error,
};

const actions = {
    /**
     * 获取指定平台的热榜排名数据
     * @param {Object} context - Vuex 上下文对象
     * @param {String} platform - 平台名称，如 'douyin' 或 'zhihu'
     */
    async fetchHotRanking({ commit }, platform) {
        commit('SET_LOADING', true);
        commit('SET_ERROR', null);
        try {
            const response = await axios.post(`/admin/setting/hotRanking`, null, {
                params: { platform },
            });
            console.log('API Response (fetchHotRanking):', response);

            // 根据后端返回的数据结构进行处理
            if (response && response.code === 200 && response.data.code === "200") {
                const data = response.data;
                console.log(data)
                commit('SET_HOT_DATA', data);
                commit('SET_PLATFORM', platform);
            } else {
                console.error('API 返回的数据结构不正确:', response);
                commit('SET_ERROR', response.msg || 'API 返回的数据结构不正确');
            }
        } catch (error) {
            console.error('获取热点排名失败:', error);
            commit('SET_ERROR', error.message || '获取热点排名失败');
        } finally {
            commit('SET_LOADING', false);
        }
    },
};

const mutations = {
    /**
     * 更新热榜数据
     * @param {Object} state - Vuex 状态对象
     * @param {Object} data - 后端返回的热榜数据
     */
    SET_HOT_DATA(state, data) {
        state.hotData = data.data;
        state.total = data.total;
        state.title = data.title;
        state.subtitle = data.subtitle;
    },

    /**
     * 设置当前平台
     * @param {Object} state
     * @param {String} platform
     */
    SET_PLATFORM(state, platform) {
        state.platform = platform;
    },

    /**
     * 设置加载状态
     * @param {Object} state
     * @param {Boolean} isLoading
     */
    SET_LOADING(state, isLoading) {
        state.loading = isLoading;
    },

    /**
     * 设置错误信息
     * @param {Object} state
     * @param {String} error
     */
    SET_ERROR(state, error) {
        state.error = error;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
